<div class="cnt-button" [class.selected]="selected" (click)="select(!selected)">
  <div class="cnt-button-copy">{{ label }}</div>
</div>
